"use strict";

exports.__esModule = true;
exports.default = {
  accordion: 22 - 1,
  acoustic_bass: 33 - 1,
  acoustic_grand_piano: 1 - 1,
  acoustic_guitar_nylon: 25 - 1,
  acoustic_guitar_steel: 26 - 1,
  agogo: 114 - 1,
  alto_sax: 66 - 1,
  applause: 127 - 1,
  bagpipe: 110 - 1,
  banjo: 106 - 1,
  baritone_sax: 68 - 1,
  bassoon: 71 - 1,
  bird_tweet: 124 - 1,
  blown_bottle: 77 - 1,
  brass_section: 62 - 1,
  breath_noise: 122 - 1,
  bright_acoustic_piano: 2 - 1,
  celesta: 9 - 1,
  cello: 43 - 1,
  choir_aahs: 53 - 1,
  church_organ: 20 - 1,
  clarinet: 72 - 1,
  clavinet: 8 - 1,
  contrabass: 44 - 1,
  distortion_guitar: 31 - 1,
  drawbar_organ: 17 - 1,
  dulcimer: 16 - 1,
  electric_bass_finger: 34 - 1,
  electric_bass_pick: 35 - 1,
  electric_grand_piano: 3 - 1,
  electric_guitar_clean: 28 - 1,
  electric_guitar_jazz: 27 - 1,
  electric_guitar_muted: 29 - 1,
  electric_piano_1: 5 - 1,
  electric_piano_2: 6 - 1,
  english_horn: 70 - 1,
  fiddle: 111 - 1,
  flute: 74 - 1,
  french_horn: 61 - 1,
  fretless_bass: 36 - 1,
  fx_1_rain: 97 - 1,
  fx_2_soundtrack: 98 - 1,
  fx_3_crystal: 99 - 1,
  fx_4_atmosphere: 100 - 1,
  fx_5_brightness: 101 - 1,
  fx_6_goblins: 102 - 1,
  fx_7_echoes: 102 - 1,
  fx_8_scifi: 104 - 1,
  glockenspiel: 10 - 1,
  guitar_fret_noise: 121 - 1,
  guitar_harmonics: 32 - 1,
  gunshot: 128 - 1,
  harmonica: 23 - 1,
  harpsichord: 7 - 1,
  helicopter: 126 - 1,
  honkytonk_piano: 4 - 1,
  kalimba: 109 - 1,
  koto: 108 - 1,
  lead_1_square: 81 - 1,
  lead_2_sawtooth: 82 - 1,
  lead_3_calliope: 83 - 1,
  lead_4_chiff: 84 - 1,
  lead_5_charang: 85 - 1,
  lead_6_voice: 86 - 1,
  lead_7_fifths: 87 - 1,
  lead_8_bass__lead: 88 - 1,
  marimba: 13 - 1,
  melodic_tom: 118 - 1,
  music_box: 11 - 1,
  muted_trumpet: 60 - 1,
  oboe: 69 - 1,
  ocarina: 80 - 1,
  orchestra_hit: 56 - 1,
  orchestral_harp: 47 - 1,
  overdriven_guitar: 30 - 1,
  pad_1_new_age: 89 - 1,
  pad_2_warm: 90 - 1,
  pad_3_polysynth: 91 - 1,
  pad_4_choir: 92 - 1,
  pad_5_bowed: 93 - 1,
  pad_6_metallic: 94 - 1,
  pad_7_halo: 95 - 1,
  pad_8_sweep: 96 - 1,
  pan_flute: 76 - 1,
  percussive_organ: 18 - 1,
  piccolo: 73 - 1,
  pizzicato_strings: 46 - 1,
  recorder: 75 - 1,
  reed_organ: 21 - 1,
  reverse_cymbal: 120 - 1,
  rock_organ: 19 - 1,
  seashore: 123 - 1,
  shakuhachi: 78 - 1,
  shamisen: 107 - 1,
  shanai: 112 - 1,
  sitar: 105 - 1,
  slap_bass_1: 37 - 1,
  slap_bass_2: 38 - 1,
  soprano_sax: 65 - 1,
  steel_drums: 115 - 1,
  string_ensemble_1: 49 - 1,
  string_ensemble_2: 50 - 1,
  synth_bass_1: 39 - 1,
  synth_bass_2: 40 - 1,
  synth_brass_1: 63 - 1,
  synth_brass_2: 64 - 1,
  synth_choir: 92 - 1,
  synth_drum: 119 - 1,
  synth_strings_1: 51 - 1,
  synth_strings_2: 52 - 1,
  taiko_drum: 117 - 1,
  tango_accordion: 24 - 1,
  telephone_ring: 125 - 1,
  tenor_sax: 67 - 1,
  timpani: 48 - 1,
  tinkle_bell: 113 - 1,
  tremolo_strings: 45 - 1,
  trombone: 58 - 1,
  trumpet: 57 - 1,
  tuba: 59 - 1,
  tubular_bells: 15 - 1,
  vibraphone: 12 - 1,
  viola: 42 - 1,
  violin: 41 - 1,
  voice_oohs: 54 - 1,
  whistle: 79 - 1,
  woodblock: 116 - 1,
  xylophone: 14 - 1
};
module.exports = exports["default"];


/** WEBPACK FOOTER **
 ** ./MidiIO/lib/constants/INSTRUMENT_MIDI_MAPPING.js
 **/